import styled, {css} from "styled-components"

import FilterBy from "@irati/ui/src/FilterBy"
import SortBy from "@irati/ui/src/SortBy"
import {Body} from "@irati/ui/src/Typography"

const commonStyles = css`
  margin-bottom: 5px;
  width: 100%;
  max-width: 100%;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    margin-bottom: 0;
    max-width: 280px;
  `}
`

export const StyledFilterBy = styled(FilterBy)`
  ${commonStyles}

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    margin-right: ${theme.spacing.one};
  `}
`

export const StyledSortBy = styled(SortBy)`
  ${commonStyles}
`

export const DisplayCount = styled(Body)``
